'use client'

import { useEffect } from 'react'
import { useChangelogStore } from '@/stores/changelogStore'
import { useLocale } from 'next-intl'
import { useUser } from '@/contexts/user'

export const ChangelogDataPreloader = () => {
  const fetchChangelogs = useChangelogStore((state) => state.fetchChangelogs)
  const locale = useLocale()
  const { user } = useUser()

  useEffect(() => {
    // Fetch initial data and on locale change
    fetchChangelogs(locale, user)
  }, [fetchChangelogs, locale, user])

  useEffect(() => {
    const handleVisibility = () => {
      if (document.visibilityState === 'visible') {
        fetchChangelogs(locale, user)
      }
    }
    const handleOnline = () => {
      fetchChangelogs(locale, user)
    }

    document.addEventListener('visibilitychange', handleVisibility)
    window.addEventListener('online', handleOnline)
    return () => {
      document.removeEventListener('visibilitychange', handleVisibility)
      window.removeEventListener('online', handleOnline)
    }
  }, [fetchChangelogs, locale, user])

  return null // This component renders nothing
}
